import { render, staticRenderFns } from "./block-stock.vue?vue&type=template&id=ec2ec812&scoped=true&"
import script from "./block-stock.vue?vue&type=script&lang=js&"
export * from "./block-stock.vue?vue&type=script&lang=js&"
import style0 from "./block-stock.vue?vue&type=style&index=0&id=ec2ec812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ec812",
  null
  
)

export default component.exports